export const getItemTypeDisplay = (item) => {
  if (!item) return "";
  if (item.type === "folder") return "FOLDER";

  const name = item.name || "";
  const ext = (item.fileExtension || name.split(".").pop() || "").toLowerCase();
  const type = (item.fileType || "").toLowerCase();

  const isYoutube =
    type.includes("youtube") ||
    ext === "youtube" ||
    name.includes("youtube.com") ||
    name.includes("youtu.be");

  if (isYoutube) return "YouTube";

  const isWebpage =
    type === "webpage" || ext === "webpage" || name.startsWith("http");

  if (isWebpage) return "URL";

  return ext.toUpperCase();
};
